import { FC, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { ArticleGroupDiscount } from "../../models/responses/articleGroupDiscount";
import { Col, Row, Spinner } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { getArticleGroupDiscounts } from "../../app/services/articleGroupDiscountService";

interface Props {}

const ArticleGroupDiscounts: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const articleGroupDiscounts: ArticleGroupDiscount[] = useSelector(
    (state: RootState) =>
      state.articleGroupDiscount.articleGroupDiscountList || [],
  );
  const loadingArticleGroupDiscounts = useSelector(
    (state: RootState) =>
      state.articleGroupDiscount.isWaitingArticleGroupDiscountGetResponse,
  );

  useEffect(() => {
    dispatch(getArticleGroupDiscounts(instance, account));
  }, [account, accounts, dispatch, instance]);

  const openArticleGroupDiscountHandler = (
    articleGroupDiscount: ArticleGroupDiscount,
  ) => {
    navigate(`/article-group-discounts/${articleGroupDiscount.id}`, {
      relative: "path",
    });
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h1>Artikelgruppsrabatter</h1>
        </Col>
        <Col className="text-end">
          <Button
            className="mt-2 ms-2"
            variant="outline-primary"
            href={`/article-group-discounts/add`}
          >
            Lägg till <Plus />
          </Button>
        </Col>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Namn</th>
            <th>Beskrivning</th>
            <th>Art.grp.id</th>
            <th>Rabatt %</th>
            <th>Skapad</th>
            <th>Uppdaterad</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {articleGroupDiscounts.map((articleGroupDiscount) => (
            <tr
              key={articleGroupDiscount.id}
              role="button"
              onClick={() =>
                openArticleGroupDiscountHandler(articleGroupDiscount)
              }
            >
              <td>{articleGroupDiscount.name}</td>
              <td>{articleGroupDiscount.description}</td>
              <td>{articleGroupDiscount.externalGroupId}</td>
              <td>{articleGroupDiscount.discountPercentage}</td>
              <td>
                {articleGroupDiscount.createdAt
                  ? new Date(articleGroupDiscount.createdAt).toLocaleDateString()
                  : "-"}
              </td>
              <td>
                {articleGroupDiscount.updatedAt
                  ? new Date(articleGroupDiscount.updatedAt).toLocaleDateString()
                  : "-"}
              </td>
              <td align="center">
                <Eye />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loadingArticleGroupDiscounts && (
        <>
          <Row className="mb-3">
            <Col className="text-center">
              <Spinner variant="primary" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default ArticleGroupDiscounts;
